import config from '../const/config';
export default (function () {
    var urlParams = new URLSearchParams(window.location.search);
    return Boolean(config.MOCK_DATA_ENABLED) && urlParams.has('payLater');
});
